import type { GamSizeMapping } from '@schibsted-nmp/advertising-shared';

import { Api } from '../Api/index.js';

export async function applySizeMapping(
  slot: googletag.Slot,
  sizeMappings: ReadonlyArray<GamSizeMapping>,
  ...abortSignals: ReadonlyArray<AbortSignal>
) {
  if (sizeMappings.length === 0) return;

  // Sort size mappings by viewport size (largest first)
  const sortedMappings = [...sizeMappings].sort(
    ({ breakpoint: widthA = 0 }, { breakpoint: widthB = 0 }) =>
      Number(widthB) - Number(widthA)
  );

  await Api(
    (googletag) => {
      const mapping = googletag.sizeMapping();

      // Add each size mapping to the builder
      for (const sizeMap of sortedMappings) {
        mapping.addSize(sizeMap.breakpoint, sizeMap.sizes);
      }

      // Check if [0,0] breakpoint already exists in mappings
      const hasZeroBreakpoint = sortedMappings.some(
        ({ breakpoint: [width, height] }) => width === 0 && height === 0
      );

      // Only add [0,0] fallback if it's not already defined
      if (!hasZeroBreakpoint) {
        // Add a fallback for when no breakpoints match (empty array)
        mapping.addSize([0, 0], []);
      }

      // Apply the size mapping to the slot
      slot.defineSizeMapping(mapping.build());
    },
    ...abortSignals
  );
}
